(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function initHero(raiz) {
    (raiz || document).querySelectorAll('[data-mt-tilt]').forEach(function (escena) {
      if (escena.dataset.mtInit) return;
      escena.dataset.mtInit = '1';
      var tarjeta = escena.querySelector('.mt-hero__tarjeta');
      if (!tarjeta || reducido) return;
      var max = parseFloat(escena.dataset.mtTilt) || 8;
      if (tactil) {
        var t = 0;
        (function bucle() {
          t += 0.012;
          tarjeta.style.setProperty('--rx', (Math.sin(t) * max * 0.4).toFixed(2) + 'deg');
          tarjeta.style.setProperty('--ry', (Math.cos(t * 0.8) * max * 0.5).toFixed(2) + 'deg');
          requestAnimationFrame(bucle);
        })();
        return;
      }
      var seccion = escena.closest('.mt-hero') || escena;
      seccion.addEventListener('mousemove', function (ev) {
        var r = tarjeta.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        px = Math.max(-1, Math.min(1, px)); py = Math.max(-1, Math.min(1, py));
        tarjeta.style.setProperty('--ry', (px * max).toFixed(2) + 'deg');
        tarjeta.style.setProperty('--rx', (-py * max).toFixed(2) + 'deg');
        tarjeta.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
        tarjeta.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
      });
      seccion.addEventListener('mouseleave', function () {
        tarjeta.style.setProperty('--rx', '0deg');
        tarjeta.style.setProperty('--ry', '0deg');
      });
    });
  }

  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hotspots]').forEach(function (cont) {
      if (cont.dataset.mtInit) return;
      cont.dataset.mtInit = '1';
      var puntos = cont.querySelectorAll('[data-mt-punto]');
      var items = cont.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('is-activo', p.dataset.mtPunto === i); p.setAttribute('aria-pressed', p.dataset.mtPunto === i); });
        items.forEach(function (it) { it.classList.toggle('is-activo', it.dataset.mtItem === i); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.mtPunto); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () { activar(it.dataset.mtItem); });
        it.addEventListener('mouseenter', function () { activar(it.dataset.mtItem); });
      });
      if (puntos[0]) activar(puntos[0].dataset.mtPunto);
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq__item').forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('is-abierto');
        btn.setAttribute('aria-expanded', abierto);
      });
    });
  }

  function initMagnetico(raiz) {
    if (tactil || reducido) return;
    (raiz || document).querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      var fuerza = parseFloat(btn.dataset.mtMagnetico) || 6;
      var zona = btn.parentElement;
      zona.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2);
        var dy = ev.clientY - (r.top + r.height / 2);
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > 160) { btn.style.transform = ''; return; }
        btn.style.transform = 'translate(' + (dx / 160 * fuerza).toFixed(1) + 'px,' + (dy / 160 * fuerza).toFixed(1) + 'px)';
      });
      zona.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (cont) {
      if (cont.dataset.mtInit) return;
      cont.dataset.mtInit = '1';
      var principal = cont.querySelector('[data-mt-principal]');
      cont.querySelectorAll('[data-mt-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = mini.dataset.mtMini;
            principal.removeAttribute('srcset');
            principal.style.opacity = 1;
          }, 150);
          cont.querySelectorAll('[data-mt-mini]').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });
      var datos = cont.querySelector('[data-mt-variantes]');
      var form = cont.querySelector('form[action*="/cart/add"]');
      if (!datos || !form) return;
      var variantes = JSON.parse(datos.textContent);
      var inputId = form.querySelector('input[name="id"]');
      var precio = cont.querySelector('[data-mt-precio]');
      var tachado = cont.querySelector('[data-mt-tachado]');
      var boton = cont.querySelector('[data-mt-boton]');
      var formato = cont.dataset.mtMoneda || '{{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
      }
      function actualizar() {
        var sel = [];
        cont.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          if (marcado) sel.push(marcado.value);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.dataset.mtTexto : boton.dataset.mtAgotado;
        }
        if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.removeAttribute('srcset'); }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      cont.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
    });
  }

  function initTodo(ev) {
    var raiz = ev && ev.target && ev.target.querySelectorAll ? ev.target : document;
    initReveals(raiz);
    initHero(raiz);
    initHotspots(raiz);
    initFaq(raiz);
    initMagnetico(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
